import React, { useState, Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { CoachTile, PrimaryButton, DarkScreenMask, InviteUserModal } from '@myplay/ui';

import { SingleCoach, HeaderTiles, SceneLoaderWrapper } from '../../components';
import { toTitleCase } from '../../utils/stringManipulations';
import { GREEN_LIGHT, WHITE } from '../../styles/colors';
import { COACHES_ROUTE, COACH } from '../../utils/constants';
import I18N from '../../I18N';
import history from '../../utils/history';
import "./Coaches.scss";

const Coaches = ({ CoachesStore, MetricsStore, TeamsStore, ClubsStore, match }) => {
  const { coaches, getCoachById } = CoachesStore;
  const { setCoachMetrics, setClubMetrics } = MetricsStore;
  const { sendInvitations } = ClubsStore;
  const { teams } = TeamsStore;
  const [shouldRenderInvite, setShouldRenderInvite] = useState(false);
  const [selectedCoach, setSelectedCoach] = useState(null);


  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const coachId = params.get("coachId");
    setClubMetrics();

    if (coachId) {
      const coach = getCoachById(coachId);
      history.replace(COACHES_ROUTE);
      handleSelectCoach(coach);
    };
  }, [])

  useEffect(() => {
    if (match.isExact && selectedCoach) {
      handleBack();
    }
  })

  const handleSend = async users => {
    await sendInvitations(users, COACH);
    setShouldRenderInvite(false);
  };

  const handleSelectCoach = coach => {
    setCoachMetrics(coach.teams);
    setSelectedCoach(coach);
    history.push(`${COACHES_ROUTE}/${coach._id}`);
  };

  const handleBack = () => {
    setSelectedCoach(null);
    setClubMetrics();
    history.push(COACHES_ROUTE);
  };

  return (
    <SceneLoaderWrapper>
      <div className="coaches" data-testid="coaches">
        {selectedCoach ?
          <SingleCoach
            coach={selectedCoach}
            onBack={handleBack}
          /> :
          <Fragment>
            <div className="coaches__header">
              <div>
                <p className="coaches__header__title">{I18N.t("COACHES").toUpperCase()}</p>
                <PrimaryButton
                  background={GREEN_LIGHT}
                  color={WHITE}
                  style={{ width: "180px", marginLeft: "0px" }}
                  onClick={() => setShouldRenderInvite(true)}
                  data-testid="invite-button"
                >
                  <span style={{ fontSize: "20px", marginRight: "5px" }}>+</span>
                  <span>{toTitleCase(I18N.t("INVITE_NEW_COACH"))}</span>
                </PrimaryButton>
              </div>
              <HeaderTiles />
            </div>
            <div className="coaches__tiles-wrapper">
              {coaches.map(coach =>
                <button key={coach._id} type="button" onClick={() => handleSelectCoach(coach)} data-testid={`tile-${coach._id}`}>
                  <CoachTile coach={coach} />
                </button>
              )}
            </div>
            <DarkScreenMask isVisible={shouldRenderInvite}>
              <InviteUserModal
                onClose={() => setShouldRenderInvite(false)}
                title={toTitleCase(I18N.t("INVITE_NEW_COACH"))}
                onSend={handleSend}
                teams={teams}
              />
            </DarkScreenMask>
          </Fragment>
        }
      </div>
    </SceneLoaderWrapper>
  );
};

Coaches.propTypes = {
  ClubsStore: PropTypes.object,
  CoachesStore: PropTypes.object,
  MetricsStore: PropTypes.object,
  TeamsStore: PropTypes.object
};


Coaches.defaulProps = {
  ClubsStore: {},
  CoachesStore: {},
  MetricsStore: {},
  TeamsStore: {}
};

export default inject("CoachesStore", "MetricsStore", "TeamsStore", "ClubsStore")(observer(Coaches));